import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { ColoredIcon } from './Icon';

interface ButtonStyle {
  $padding?: string;
  $fontSize?: string;
  $selected?: boolean;
}
const Button = styled.button<ButtonStyle>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 85px;
  ${p => p.$padding && `padding: ${p.$padding}`};
  background-color: #ffffff;
  border: 1px solid #f3f3f3;
  border-radius: 8px;

  font-size: ${p => p.$fontSize ?? '14px'};
  font-weight: 500;
  color: var(--HPACS_Text_Light_Grey, #a3a6ab);
  white-space: nowrap;
  cursor: pointer;

  ${p =>
    p.$selected &&
    `
      background-color: #2e5be0;
      color: #ffffff;
    `};
`;

interface ButtonWithIconProps extends ButtonStyle {
  text?: string | ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  icon?: string;
  iconWidth?: string;
}
export const ButtonWithIcon = ({
  text,
  icon,
  iconWidth,
  onClick,
  disabled,
  ...buttonStyle
}: ButtonWithIconProps) => {
  return (
    <Button {...buttonStyle} onClick={onClick} disabled={disabled}>
      {icon?.length && (
        <ColoredIcon
          width="24px"
          height="24px"
          margin="0px 11px 0px 0px"
          imageUrl={icon}
          imageWidth={iconWidth ?? '18px'}
          color="var(--HPACS_Text_Light_Grey, #a3a6ab)"
        />
      )}
      {text}
    </Button>
  );
};
